import { tipItems } from '@/mocks/haijiao';

export default function Tips() {
  return (
    <section id="tips" className="py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <p className="text-sm font-semibold tracking-widest text-accent-600">海角吃瓜技巧</p>
          <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-foreground-950 md:text-4xl">
            四件小事，吃得更明白
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-foreground-600">
            技巧不必花哨，贵在养成习惯。把这四条放进日常，比收集一百条理论更受用。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {tipItems.map((t, idx) => (
            <article
              key={t.title}
              className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-6 transition-colors hover:bg-background-100"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                <i className={`${t.icon} text-2xl`}></i>
              </span>
              <p className="mt-5 font-heading text-lg font-semibold text-foreground-950">{t.title}</p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t.desc}</p>
              <p className="mt-auto pt-4 font-heading text-4xl font-bold text-background-200">
                0{idx + 1}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}